export const dnldUserData = (builder) => ({
    dnldUserData: builder.mutation({
      query: ({ user_type, search, status, login_user_type, created_by_userid, loggedin_user_id, user_type_id, }) => {
        return {
          url: '/download_user_details',
          method: 'GET',
          params: { user_type, search, status, login_user_type, created_by_userid, loggedin_user_id, user_type_id, },
          headers: {
            'Content-Type': 'text/csv',
          },
          responseHandler: (response)=>response.blob(),
        };
      },
    }),
  });
  